import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PostComponent } from './post/post';
import { MapComponent } from './map/map';
import { DiscoverMapComponent } from './discover-map/discover-map';
import { IonicModule, Loading } from 'ionic-angular';
import { LocationStopCardComponent } from './location-stop-card/location-stop-card';
import { NotificationComponent } from './notification/notification';
import { AccountInfoComponent } from './account-info/account-info';
import { JobSearchFormComponent } from './job-search-form/job-search-form';
import { PipesModule } from '../pipes/pipes.module';
import { CommentsAndRepliesComponent } from './comments-and-replies/comments-and-replies';
import { CommentComponent } from './comment/comment';
import { PlacesSliderComponent } from './places-slider/places-slider';
import { UserBadgeComponent } from './user-badge/user-badge';
import { FeedComponent } from './feed/feed';
import { UserTagComponent } from './user-tag/user-tag';
import { QuillContentComponent } from './quill-content/quill-content';
import { ImageMetadataWrapperComponent } from './image-metadata-wrapper/image-metadata-wrapper';
import { UserAvatarComponent } from './user-avatar/user-avatar';
import { PlaceIconComponent } from './place-icon/place-icon';
import { AllBadgesComponent } from './all-badges/all-badges';
import { TripTimelineComponent } from './trip-timeline/trip-timeline';
import { TripImageComponent } from './trip-image/trip-image';
import { ConfirmRouteStopCardComponent } from './confirm-route-stop-card/confirm-route-stop-card';
import { StarsComponent } from './stars/stars';
import { AddCommentComponent } from './add-comment/add-comment';
import { AutosizeModule } from 'ngx-autosize';
import { PwReportingButtonsComponent } from './pw-reporting-buttons/pw-reporting-buttons';
import { DirectivesModule } from '../directives/directives.module';
import { TripStatsComponent } from './trip-stats/trip-stats';
import { ProgressBarComponent } from './progress-bar/progress-bar';
import { PostLoaderComponent } from './post-loader/post-loader';
import { EditPlaceReviewComponent } from './edit-place-review/edit-place-review';
import { PlaceReviewsSummaryComponent } from './place-reviews-summary/place-reviews-summary';
import { ServiceCardComponent } from './service-card/service-card';
import { ReviewsForPlaceComponent } from './reviews-for-place/reviews-for-place';
import { ImagesGridComponent } from './images-grid/images-grid';
import { PlaceCardComponent } from './place-card/place-card';
import { MainNavComponent } from './main-nav/main-nav';
import { MainSearchComponent } from './main-search/main-search';
import { SlideOverComponent } from './slide-over/slide-over';
import { NewMessageUserSelectorComponent } from './new-message-user-selector/new-message-user-selector';
import { SubnavAndSlidesComponent } from './subnav-and-slides/subnav-and-slides';
import { CustomInfiniteScrollComponent } from './custom-infinite-scroll/custom-infinite-scroll';
import { WaypointComponent } from './waypoint/waypoint';
import { AdTakeoverComponent } from './ad-takeover/ad-takeover';
import { NewGroupChatStartupComponent } from './new-group-chat-startup/new-group-chat-startup';
import { UserActionModalComponent } from './user-action-modal/user-action-modal';
import { ServicesDashboardComponent } from './services-dashboard/services-dashboard';
import { ServicesIconComponent } from './services-dashboard/icons/services-icon';

import { TagFeedMenuComponent } from './tag-feed-menu/tag-feed-menu';
import { CustomTagComponent } from './custom-tag/custom-tag';
import { ActiveCustomTagsCommponent } from './active-custom-tags/active-custom-tags';
import { PostBoostComponent } from './post-boost/post-boost';
import { AnnouncementComponent } from './announcement/announcement';
import { ViewAllTagsComponent } from './view-all-tags/view-all-tags';
import { PolicyFooterComponent } from './policy-footer/policy-footer';
import { karmaMilesInstructionsComponent } from './karma-miles-instructions/karma-miles-instructions';
import { PreviewModeOverlayComponent } from './preview-mode/preview-mode-overlay/preview-mode-overlay';
import { PreviewModeHeaderComponent } from './preview-mode/preview-mode-header/preview-mode-header';
import { JobCarouselComponent } from './job-carousel/job-carousel';
import { DrawerComponent } from './drawer/drawer';
import { AccountMenuToggleComponent } from './account-menu-toggle/account-menu-toggle';
import { LoadingSpinner } from './loading-spinner/loading-spinner';
import { ReviewModalComponent } from './review-modal/review-modal';
import { JobCardComponent } from './job-card/job-card';
import { appPostPreviewBannerComponent } from './app-post-preview-banner/app-post-preview-banner';
import { SwipeDrawerComponent } from './swipe-drawer/swipe-drawer';
import { IntroductionPostPromptComponent } from './introduction-post-prompt/introduction-post-prompt';
import { InviteSlideoverComponent } from './invite-slideover/invite-slideover';
import { InviteFriendsComponent } from './invite-friends/invite-friends';
import { SpeedBumpsComponent } from './speed-bumps/speed-bumps';
import { CommentTagUsersComponent } from './comment-tag-users/comment-tag-users';
import { AdVideosComponent } from './ad-videos/ad-videos';
import { PillSliderSubMenuComponent } from './pill-slider-sub-menu/pill-slider-sub-menu';
import { ChatsComponent } from './_live-chat/chats/chats';
import { NgxEmojiPickerModule } from 'ngx-emoji-picker';
import { EmojiPickerComponent } from './_live-chat/emoji-picker/emoji-picker';
import { LCMessageComponent } from './_live-chat/message/message';
import { LCTypingUsersComponent } from './_live-chat/typing-users/typing-users';
import { LCMessageBarComponent } from './_live-chat/message-bar/message-bar';
import { LCRoomHeaderUsersComponent } from './_live-chat/chat-header-users/chat-header-users';
import { ChatCarouselComponent } from './_live-chat/chat-carousel/chat-carousel';
import { EmojiPickerLauncherComponent } from './_live-chat/emoji-picker-launcher/emoji-picker-launcher';
import { LCReplyToReplyComponent } from './_live-chat/reply-to-reply/reply-to-reply';
import { LcPromptHeaderComponent } from './lc-prompt-header/lc-prompt-header';
import { UpdateAppBannerComponent } from '../pages/update-app-banner/update-app-banner';
import { VerificationPromptsComponent } from './verification-prompts/verification-prompts';
import { VerificationShortPromptComponent } from './verification-short-prompt/verification-short-prompt';
import { VerificationDrawerPromptsComponent } from './verification-drawer-prompts/verification-drawer-prompts';
import { HomeFabsComponent } from './home-fabs/home-fabs';
import { LCChatWindowComponent } from './_live-chat/chat-window/chat-window';
import { TaggingUsersComponent } from './tagging-users/tagging-users';
import { LCLinksComponent } from './_live-chat/links/links';
import { NewsPageComponent } from './news/news';
import { LiveChatGiveAwayComponent } from './_live-chat/sponsorship-giveaway-announcement/sponsorship-giveaway-announcement';
import { CountDownTimerComponent } from './count-down-timer/count-down-timer';
import { AdTags } from './ad-tags/ad-tags';
@NgModule({
  declarations: [
    PostComponent,
    MapComponent,
    DiscoverMapComponent,
    LocationStopCardComponent,
    NotificationComponent,
    AnnouncementComponent,
    DrawerComponent,
    AccountMenuToggleComponent,
    AccountInfoComponent,
    JobSearchFormComponent,
    CommentsAndRepliesComponent,
    CommentComponent,
    PlacesSliderComponent,
    UserBadgeComponent,
    FeedComponent,
    UserTagComponent,
    QuillContentComponent,
    ImageMetadataWrapperComponent,
    UserAvatarComponent,
    PlaceIconComponent,
    AllBadgesComponent,
    TripTimelineComponent,
    TripImageComponent,
    ConfirmRouteStopCardComponent,
    StarsComponent,
    AddCommentComponent,
    PwReportingButtonsComponent,
    TripStatsComponent,
    ProgressBarComponent,
    PostLoaderComponent,
    EditPlaceReviewComponent,
    PlaceReviewsSummaryComponent,
    ServiceCardComponent,
    ReviewsForPlaceComponent,
    ImagesGridComponent,
    PlaceCardComponent,
    MainNavComponent,
    MainSearchComponent,
    SlideOverComponent,
    NewMessageUserSelectorComponent,
    SubnavAndSlidesComponent,
    CustomInfiniteScrollComponent,
    WaypointComponent,
    AdTakeoverComponent,
    NewGroupChatStartupComponent,
    LoadingSpinner,
    UserActionModalComponent,
    ServicesDashboardComponent,
    ServicesIconComponent,
    TagFeedMenuComponent,
    CustomTagComponent,
    ActiveCustomTagsCommponent,
    PostBoostComponent,
    ViewAllTagsComponent,
    PolicyFooterComponent,
    karmaMilesInstructionsComponent,
    PreviewModeOverlayComponent,
    PreviewModeHeaderComponent,
    ReviewModalComponent,
    JobCardComponent,
    JobCarouselComponent,
    appPostPreviewBannerComponent,
    SwipeDrawerComponent,
    IntroductionPostPromptComponent,
    InviteSlideoverComponent,
    InviteFriendsComponent,
    SpeedBumpsComponent,
    CommentTagUsersComponent,
    AdVideosComponent,
    PillSliderSubMenuComponent,
    ChatsComponent,
    EmojiPickerComponent,
    LCMessageComponent,
    LCTypingUsersComponent,
    LCMessageBarComponent,
    LCRoomHeaderUsersComponent,
    ChatCarouselComponent,
    EmojiPickerLauncherComponent,
    LCReplyToReplyComponent,
    LcPromptHeaderComponent,
    UpdateAppBannerComponent,
    VerificationPromptsComponent,
    VerificationShortPromptComponent,
    VerificationDrawerPromptsComponent,
    HomeFabsComponent,
    LCChatWindowComponent,
    TaggingUsersComponent,
    LCLinksComponent,
    NewsPageComponent,
    NewsPageComponent,
    LiveChatGiveAwayComponent,
    CountDownTimerComponent,
    AdTags
  ],
  imports: [
    IonicModule,
    PipesModule,
    AutosizeModule,
    DirectivesModule,
    NgxEmojiPickerModule,
  ],
  exports: [
    PostComponent,
    MapComponent,
    DiscoverMapComponent,
    LocationStopCardComponent,
    NotificationComponent,
    AnnouncementComponent,
    AccountInfoComponent,
    DrawerComponent,
    AccountMenuToggleComponent,
    JobSearchFormComponent,
    CommentsAndRepliesComponent,
    CommentComponent,
    PlacesSliderComponent,
    UserBadgeComponent,
    FeedComponent,
    UserTagComponent,
    QuillContentComponent,
    ImageMetadataWrapperComponent,
    UserAvatarComponent,
    PlaceIconComponent,
    AllBadgesComponent,
    TripTimelineComponent,
    TripImageComponent,
    ConfirmRouteStopCardComponent,
    StarsComponent,
    AddCommentComponent,
    PwReportingButtonsComponent,
    TripStatsComponent,
    ProgressBarComponent,
    PostLoaderComponent,
    EditPlaceReviewComponent,
    PlaceReviewsSummaryComponent,
    ServiceCardComponent,
    ReviewsForPlaceComponent,
    ImagesGridComponent,
    PlaceCardComponent,
    MainNavComponent,
    MainSearchComponent,
    SlideOverComponent,
    NewMessageUserSelectorComponent,
    SubnavAndSlidesComponent,
    CustomInfiniteScrollComponent,
    WaypointComponent,
    AdTakeoverComponent,
    NewGroupChatStartupComponent,
    LoadingSpinner,
    UserActionModalComponent,
    ServicesDashboardComponent,
    ServicesIconComponent,
    TagFeedMenuComponent,
    CustomTagComponent,
    ActiveCustomTagsCommponent,
    PostBoostComponent,
    ViewAllTagsComponent,
    PolicyFooterComponent,
    karmaMilesInstructionsComponent,
    PreviewModeOverlayComponent,
    PreviewModeHeaderComponent,
    ReviewModalComponent,
    JobCardComponent,
    JobCarouselComponent,
    appPostPreviewBannerComponent,
    SwipeDrawerComponent,
    IntroductionPostPromptComponent,
    InviteSlideoverComponent,
    InviteFriendsComponent,
    SpeedBumpsComponent,
    CommentTagUsersComponent,
    AdVideosComponent,
    PillSliderSubMenuComponent,
    ChatsComponent,
    EmojiPickerComponent,
    LCMessageComponent,
    LCTypingUsersComponent,
    LCMessageBarComponent,
    LCRoomHeaderUsersComponent,
    ChatCarouselComponent,
    EmojiPickerLauncherComponent,
    LCReplyToReplyComponent,
    LcPromptHeaderComponent,
    UpdateAppBannerComponent,
    VerificationPromptsComponent,
    VerificationShortPromptComponent,
    VerificationDrawerPromptsComponent,
    HomeFabsComponent,
    LCChatWindowComponent,
    TaggingUsersComponent,
    NewsPageComponent,
    LiveChatGiveAwayComponent,
    CountDownTimerComponent,
    AdTags,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts